import * as yup from "yup";

const passwordComplexityRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,30}$/;

const passwordMessage = `
  Password must meet the following criteria:
  • 8-30 characters
  • At least one uppercase letter
  • At least one lowercase letter
  • At least one number
  • At least one special character
  `.trim();

export const signupSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup
    .string()
    .matches(passwordComplexityRegex, passwordMessage)
    .required("Password is required"),
});
export const loginSchema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup.string().required("Password is required"),
});

export const resetSchema = yup.object({
  email: yup.string().email("Invalid email").required("Email is required"),
});

export const confirmResetPasswordSchema = yup.object().shape({
  password: yup
    .string()
    .matches(passwordComplexityRegex, passwordMessage)
    .required("Password is required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required(),
});
